import {
  CHARCOAL,
  IRON,
  PRIMARY_BLUE,
  PRIMARY_TEXT,
  TERTIARY_TEXT
} from 'styles/Colors';
import { visuallyHidden } from 'styles/Accessibility';
import CheckboxCheck from 'images/CheckboxCheck.svg';
import React from 'react';

const labelStyle = {
  color: TERTIARY_TEXT,
  cursor: 'pointer',
  display: 'flex',
  transition: 'all 0.3s ease-in-out'
};

const checkedLabelStyle = {
  color: PRIMARY_TEXT
};

const checkboxStyle = {
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  height: '1.5rem',
  justifyContent: 'center',
  margin: '0.125rem 0.75rem 0 0',
  width: '1.5rem',
  border: `1px solid ${TERTIARY_TEXT}`,
  borderRadius: '50%',
  flexShrink: 0,
  transition: 'all 0.3s ease-in-out'
};

const checkedCheckboxStyle = {
  border: `1px solid ${PRIMARY_BLUE}`
};

const checkmarkStyle = {
  opacity: 0,
  fill: PRIMARY_BLUE,
  height: '1rem',
  width: '1rem',
  transition: 'opacity 0.3s ease-in-out'
};

const checkedCheckmarkStyle = {
  opacity: 1,
  transition: 'opacity 0.3s ease-in-out'
};

function Checkbox({
  id,
  label,
  name,
  onChange,
  value,
  dataAttrs,
  additionalCheckboxStyle = {},
  additionalLabelStyle = {},
  additionalCheckmarkStyle = {},
  disabled
}) {
  return (
    <label
      css={[
        labelStyle,
        value ? checkedLabelStyle : null,
        additionalLabelStyle,
        disabled ? { color: IRON } : { color: CHARCOAL }
      ]}
      htmlFor={id}
    >
      <input
        type='checkbox'
        checked={value}
        id={id}
        name={name}
        css={visuallyHidden}
        onChange={onChange}
        disabled={disabled}
        {...dataAttrs}
      />
      <div
        role='checkbox'
        css={[
          checkboxStyle,
          value ? checkedCheckboxStyle : null,
          additionalCheckboxStyle
        ]}
        aria-checked={value}
      >
        <CheckboxCheck
          title='checkmark'
          css={[
            checkmarkStyle,
            value ? checkedCheckmarkStyle : null,
            additionalCheckmarkStyle
          ]}
        />
      </div>
      {label}
    </label>
  );
}

export default Checkbox;
